
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2019
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
  "createDashboardTitle": "יצירת לוח מחוונים",
  "dashboard": "לוח מחוונים",
  "createStoryTitle": "יצירת סיפור",
  "story": "סיפור",
  "createAV": "יצירה",
  "createAvEditNameLabel": "1. תנו שם לתצוגה",
  "createAvSelectTemplateLabel": "2. בחרו תבנית",
  "singlePageLayoutLabel": "מתכונת דף יחיד",
  "tabLayoutLabel": "מתכונת עם לשוניות",
  "slideShowLayoutLabel": "מתכונת מצגת שקופיות",
  "panAndZoomLayoutLabel": "מתכונת סיור מודרך",
  "panAndZoomShimLayoutFooter": "מתכונת סיור מודרך היא אוסף של סצנות על יריעה אחת. כשמריצים סיפור מסוג זה, התצוגה מתמקדת ונגללת לכל סצנה לפי סדר. תצוגה זו שונה מתצוגת מצגת שקופיות, שבה כל סצנה מוצגת ביריעה חדשה. מתכונת הסידור המודרך עם שלוש סצנות המחוברות בווקים מאפשרת לכם ליצור רצף סצנות אופקי. אפשרות זו שימושית להצגת ציר זמן.",
  "infographicsLayoutLabel": "מתכונת אינפוגרפיקה",
  "panAndZoomShimLayoutLabel": "מתכונת סיור מודרך",
  "freeformTemplate": "צורה חופשית",
  "freeformTemplateDesc": "המחשות במתכונת צורה חופשית מופיעות בדיוק בגודל ובמיקום שבהם הצבתם אותן בתצוגה, ללא תלות בגודל מסך. במתכונות אחרות, הגודל והמיקום של ההמחשות מותאמים כך שייכנסו במסך.",
  "NoTemplate": "צורה חופשית",
  "Template1": "ריק",
  "Template2": "כותרת 1 על  2",
  "Template3": "2 על 1",
  "Template4": "4 על 1",
  "Template5": "כותרת תחתונה 1 על 2",
  "Template6": "3 ליד 1 מעל 1",
  "Template7": "4 ליד 3 מעל 1",
  "Template8": "2 מעל 3 על 2",
  "Template9": "2 על 2",
  "Template10": "1 על  2 ליד 2 על 2 מעל 1",
  "Template11": "3 על 1 מעל 1 על 2",
  "Template12": "2 על 1 ליד 1 על 2",
  "Template13": "אחד ליד 1 על 2 ליד 1 על 4",
  "Infographics1": "ריק",
  "Infographics2": "4 שורות",
  "Infographics3": "4 שורות עם כותרות",
  "Infographics4": "2 על 4",
  "Infographics5": "תצוגה עליונה גדולה עם 2 על 2",
  "Infographics6": "2 על 4 עם מרווח אנכי",
  "Infographics7": "2 על 4 מדורג",
  "Infographics8": "מגרש טניס",
  "Infographics9": "3 על 4",
  "Infographics10": "4 על 8",
  "PanAndZoomShim1": "5 סצנות המסודרות בצורה מלבנית",
  "PanAndZoomShim2": "4 סצנות המסודרות בצורת גרם מדרגות, העולה משמאל לימין.",
  "PanAndZoomShim3": "6 סצנות המסודרות בצורה מלבנית",
  "PanAndZoomShim4": "7 סצנות המסודרות בצורה מלבנית, עם 6 סצנות קטנות בראש וסצנה גדולה אחת בתחתית",
  "PanAndZoomShim5": "3 סצנות, עם 2 סצנות קטנות בראש וסצנה גדולה אחת בתחתית",
  "PanAndZoomShim6": "רצף של 4 סצנות המסודרות אופקית",
  "createAvDashboardLabel": "לוח מחוונים",
  "createAvDataStoryLabel": "סיפור",
  "createAvSinglePageLabel": "דף יחיד",
  "createAvTabLabel": "לשוניות",
  "createAvInfographicsLabel": "אינפוגרפיקה",
  "createAvSlideShowLabel": "מצגת שקופיות",
  "createAvPanAndZoomLabel": "סיור מודרך",
  "sourcePaneLabel": "מקורות שנבחרו",
  "backLabel": "חזרה",
  "addSourceLabel": "הוספה כמקור",
  "intentSearchLabel": "חיפוש כוונה",
  "pinLabel": "נעיצה",
  "errorLoadingDataSetMetaData": "אירעה שגיאה בקריאת המטא-נתונים",
  "errorLoadingDataSets": "אירעה שגיאה בטעינת רשימת ערכות הנתונים",
  "errorLoadingDataSet": "המטא-נתונים עבור ערכת הנתונים '%{datasetName}'לא נטענו. פנו אל המנהלן כדי לקבל פרטים.",
  "okButton": "אישור",
  "cancelButton": "ביטול",
  "selectTemplateLabel": "בחרו תבנית",
  "noSourcesSelectedLabel": "לא נבחרו מקורות",
  "find_label": "איתור",
  "noDashboardFound": "לא ניתן לאחזר את לוח המחוונים. או שהוא כבר אינו קיים או שאין לכם הרשאות מספיקות להציג אותו.",
  "errorLabel": "שגיאה",
  "defaultName": "לוח מחוונים חדש",
  "defaultStoryName": "סיפור חדש",
  "noDashboardCapability": "אין לכם היכולת להריץ את יישום לוח המחוונים",
  "noDashboardPermision": "אין לכם הרשאות מספיקות כדי להציג לוח מחוונים זה",
  "sourceNotFound": "לא ניתן לטעון ההמחשה, מפני שהמקור המשויך שלה '%{sourceName}' אינו זמין.",
  "intentSearchTitle": "יצירת המחשה המבוססת על החיפוש שלכם",
  "cmDuplicateName": "פריט בשם זה כבר קיים.‏ נסו שם אחר",
  "cmEmptySelection": "לוח המחוונים נמחק. נסו לשמור כלוח מחוונים חדש.",
  "propTheme": "ערכות חזותיות",
  "defaultThemeLabel": "ברירת מחדל",
  "lightThemeLabel": "בהיר",
  "darkThemeLabel": "כהה",
  "noSceneTransitionLabel": "ללא",
  "sceneTransitionPropertyLabel": "מעבר בין סצנות",
  "animatedPathSceneTransitionLabel": "נתיב מונפש",
  "sweepSceneTransitionLabel": "Sweep",
  "animatedPathCoachmarkTitle": "נתיב מונפש",
  "animatedPathCoachmarkContents": "כדי להנפיש אובייקט מסצנה אחת לאחרת, שכפלו סצנה עם אובייקט. לאחר מכן, העבירו, סובבו או שנו את גודלו של האובייקט המשוכפל בסצנה החדשה.",
  "titleTextLabel": "כותרת",
  "titleSmallTextLabel": "כותרת קטן",
  "subtitleTextLabel": "כותרת משנה",
  "bodyTextLabel": "גוף",
  "bodySmallTextLabel": "גוף קטן",
  "captionTextLabel": "כיתוב",
  "quoteTextLabel": "ציטוט",
  "quoteSmallTextLabel": "ציטוט קטן",
  "responsiveTextLabel": "גודל אוטומטי",
  "mediaWidgetLabel": "מדיה",
  "webpageWidgetLabel": "דף רשת",
  "imageWidgetLabel": "תמונה",
  "textWidgetLabel": "תמליל",
  "editDashboardCoachMarkTitle": "עריכת לוח מחוונים",
  "editDashboardCoachMarkContents": "לחצו על איקון העפרון כדי לערוך לוח מחוונים זה.",
  "editStoryCoachMarkTitle": "עריכת סיפור",
  "editStoryCoachMarkContents": "לחצו על איקון העפרון כדי לערוך את הסיפור.",
  "addDataCoachMarkTitle": "הוספת נתונים",
  "addDataDashboardCoachMarkContents": "גררו ושחררו נתונים מחלונית הנתונים אל לוח המחוונים שלכם.",
  "addDataStoryCoachMarkContents": "גררו ושחררו נתונים מחלונית הנתונים אל הסיפור שלכם.",
  "expandSceneCoachmarkTitle": "פתיחת ציר זמן",
  "expandSceneCoachmarkContents": "כדי להנפיש סצנה, התאימו את נראות האובייקט בהתבסס על זמן ומשך.",
  "overviewCoachmarkTitle": "סצנות סקירה",
  "overviewCoachmarkContents": "השתמשו בסצנות הסקירה בהתחלת הסיפור ובסופו כדי להציג את התמונה הגדולה של כל הסצנות. מסקירת סצנה, לחצו וגררו סצנה כדי להחליף אותה בסצנה אחרת. תוכלו להציג או להסתיר את סצנות הסקירה בתכונות הסיפור.",
  "panAndZoomShimCoachmarkTitle": "סיור מודרך",
  "panAndZoomShimCoachmarkContents": "בחרו סוג סיפור זה כדי ליצור מונפשת המתקדמת ונגללת מסצנה לסצנה.",
  "timelineHighlightTitle": "הבלטה",
  "addTimelineHighlight": "הוספת הבלטה",
  "editTimelineHighlight": "עריכת הבלטה",
  "timelineAnimationProperties": "פתיחת תכונות הנפשה",
  "timelineMoveWidget": "פקד ציר הזמן הועבר אל %{newStartTime} עד %{newEndTime}",
  "timelineMoveWidgetStartTime": "שעת ההתחלה של פקד ציר הזמן השתנה לשעה %{newStartTime}",
  "timelineMoveWidgetEndTime": "שעת הסיום של פקד ציר הזמן השתנה לשעה %{newEndTime}",
  "timelineMoveWidgetDown": "פקד ציר הזמן הועבר למטה",
  "timelineMoveWidgetUp": "פקד ציר הזמן הועבר למעלה",
  "noMatchDatasets": "לא נמצאו ערכות נתונים תואמות.",
  "dataAssetPropertiesLabel": "תכונות המחשה",
  "modelFilter": "מסנן",
  "invertSelectionToolTip": "היפוך בחירות מסננים",
  "clearFilterValueToolTip": "ניקוי ערכי מסנן",
  "invertFilterSelection": "היפוך",
  "clearTextFilterValue": "ניקוי",
  "filterConditionLabel": "תנאי מסנן",
  "applyFilter": "החלת מסנן",
  "itemCountText": "%{itemCount} פריטים נבחרו",
  "itemExcludeCountText": "%{itemCount} פריטים סוננו",
  "moreMembers": "הצגת יותר...‏",
  "searchHierarchyMembers": "שימוש בחיפוש לאיתור איברים...‏",
  "propHideEmpty": "הסתרת ריק",
  "propColorOrder": "סדר צבעים",
  "propElementColor": "צבע מרכיב המחשה חזותית",
  "propLineColor": "צבע קו",
  "propLineAndSymbolColor": "צבע קווים וסמלים",
  "propColumnColor": "צבע עמודה",
  "propBarColor": "צבע טור",
  "propWordColor": "צבע מילה",
  "propAreaColor": "צבע שטח",
  "propRadialbarColor": "צבע עמודה מוקדית",
  "propColorPalettes": "בוררי צבעים",
  "propHideLeafNode": "הסתרת תוויות מובילות",
  "propOpacity": "אטימות",
  "propOpacityDescription": "הגדלה או הקטנה של אטימות האובייקט. הקלידו ערך בטווח 0 עד 100",
  "addATab": "הוספת לשונית חדשה",
  "areaChartCaption": "שטחים",
  "areaChartDataSlot_categoriesLabel": "תווית ציר",
  "areaChartDataSlot_valuesLabel": "ערך",
  "areaChartProp_colorPaletteLabel": "בוררי צבעים",
  "areaChartProp_lineColorLabel": "צבע שטח",
  "areaChartProp_interpolationLabel": "קווים חלקים",
  "areaChartProp_interpolationDescription": "הקווים המתחברים לנקודות הנתונים מעוקלים.",
  "areaChartProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "areaChartProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "areaChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "areaChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "areaChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "areaChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "areaChartProp_suppressZerosLabel": "הסתרת ריק",
  "areaChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "barChartCaption": "טורים",
  "barChartDataSlot_categoriesLabel": "תווית ציר",
  "barChartDataSlot_valuesLabel": "ערך",
  "barChartProp_colorPaletteLabel": "בוררי צבעים",
  "barChartProp_elementColorLabel": "צבע טור",
  "barChartProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "barChartProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "barChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "barChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "barChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "barChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "barChartProp_suppressZerosLabel": "הסתרת ריק",
  "barChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "columnChartCaption": "עמודה",
  "columnChartDataSlot_categoriesLabel": "תווית ציר",
  "columnChartDataSlot_valuesLabel": "ערך",
  "columnChartProp_colorPaletteLabel": "בוררי צבעים",
  "columnChartProp_elementColorLabel": "צבע עמודה",
  "columnChartProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "columnChartProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "columnChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "columnChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "columnChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "columnChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "columnChartProp_suppressZerosLabel": "הסתרת ריק",
  "columnChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "bubbleChartCaption": "בועות",
  "bubbleChartDataSlot_xAxisLabel": "ציר אופקי",
  "bubbleChartDataSlot_yAxisLabel": "ציר אנכי",
  "bubbleChartDataSlot_sizeLabel": "גודל לפי",
  "bubbleChartDataSlot_colorLabel": "צבע לפי",
  "bubbleChartProp_colorPaletteLabel": "ערכות צבעים",
  "bubbleChartProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "bubbleChartProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "bubbleChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "bubbleChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "bubbleChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "bubbleChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "bubbleChartProp_hideLegendLabel": "הסתרת מקרא",
  "bubbleChartProp_hideLegendDescription": "הסתרת המקרא.",
  "bubbleChartProp_legendPositionLabel": "מיקום מקרא",
  "lineChartCaption": "קו",
  "lineChartDataSlot_categoriesLabel": "תווית ציר",
  "lineChartDataSlot_valuesLabel": "ערך",
  "lineChartProp_colorPaletteLabel": "בוררי צבעים",
  "lineChartProp_lineColorLabel": "צבע קווים וסמלים",
  "lineChartProp_symbolShapeLabel": "צורת סמל",
  "lineChartProp_hideSymbolsLabel": "הסתרת סמלים",
  "lineChartProp_hideSymbolsDescription": "הסתרת סמלים",
  "lineChartProp_hideDataLinesLabel": "הסתרת קווים",
  "lineChartProp_hideDataLinesDescription": "הסתרת קווים",
  "lineChartProp_interpolationLabel": "קווים חלקים",
  "lineChartProp_interpolationDescription": "הקווים המתחברים לנקודות הנתונים מעוקלים.",
  "lineChartProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "lineChartProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "lineChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "lineChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "lineChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "lineChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "lineChartProp_suppressZerosLabel": "הסתרת ריק",
  "lineChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "packedBubbleChart1CatCaption": "בועות דחוס",
  "packedBubbleChart1CatDataSlot_categoriesLabel": "קטגוריות",
  "packedBubbleChart1CatDataSlot_sizeLabel": "גודל לפי",
  "packedBubbleChart1CatProp_colorPaletteLabel": "בוררי צבעים",
  "packedBubbleChart1CatProp_elementColorLabel": "צבע בועה",
  "packedBubbleChart1CatProp_hideLabelLabel": "הסתרת תווית",
  "packedBubbleChart1CatProp_hideValueLabel": "הסתרת ערך",
  "packedBubbleChart1CatProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "packedBubbleChart1CatProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "packedBubbleChart1CatProp_suppressZerosLabel": "הסתרת ריק",
  "packedBubbleChart1CatProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "heatChartCaption": "חום",
  "heatChartDataSlot_valuesLabel": "חום לפי",
  "heatChartDataSlot_xAxisLabel": "ציר אופקי",
  "heatChartDataSlot_yAxisLabel": "ציר אנכי",
  "heatChartProp_colorPaletteLabel": "ערכות צבעים",
  "heatChartProp_heatScalePaletteLabel": "סדר צבעים",
  "heatChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "heatChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "heatChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "heatChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "heatChartProp_suppressZerosLabel": "הסתרת ריק",
  "heatChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "heatChartProp_hideLegendLabel": "הסתרת מקרא",
  "heatChartProp_hideLegendDescription": "הסתרת המקרא.",
  "heatChartProp_legendPositionLabel": "מיקום מקרא",
  "pieChartCaption": "עוגה",
  "pieChartDataSlot_categoriesLabel": "קטגוריות",
  "pieChartDataSlot_valuesLabel": "ערך",
  "pieChartProp_colorPaletteLabel": "בוררי צבעים",
  "pieChartProp_hideRadialValueLabel": "הסתרת ערך",
  "pieChartProp_pieAsDonutLabel": "הצגה כתרשים טבעת",
  "pieChartProp_pieAsDonutDescription": "הצגה כתרשים טבעת",
  "pieChartProp_suppressZerosLabel": "הסתרת ריק",
  "pieChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "pieChartProp_hideLegendLabel": "הסתרת מקרא",
  "pieChartProp_hideLegendDescription": "הסתרת המקרא.",
  "pieChartProp_legendPositionLabel": "מיקום מקרא",
  "map1measureCaption": "מפה",
  "map1measureDataSlot_categoriesLabel": "שטחים",
  "map1measureDataSlot_valuesLabel": "חום שטחים",
  "map1measureProp_colorPaletteLabel": "בוררי צבעים",
  "map1measureProp_heatScalePaletteLabel": "סדר צבעים",
  "map1measureProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "map1measureProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "map1measureProp_suppressZerosLabel": "הסתרת ריק",
  "map1measureProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "map1measureProp_hideLegendLabel": "הסתרת מקרא",
  "map1measureProp_hideLegendDescription": "הסתרת המקרא.",
  "map1measureProp_legendPositionLabel": "מיקום מקרא",
  "radialChartCaption": "רדיאלי",
  "radialChartDataSlot_categoriesLabel": "קטגוריות",
  "radialChartDataSlot_valuesLabel": "ערך",
  "radialChartProp_colorPaletteLabel": "בוררי צבעים",
  "radialChartProp_elementColorLabel": "צבע עמודה מוקדית",
  "radialChartProp_hideRadialTitleLabel": "הסתרת כותרת",
  "radialChartProp_hideRadialValueLabel": "הסתרת ערך",
  "radialChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "radialChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "radialChartProp_suppressZerosLabel": "הסתרת ריק",
  "radialChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "pointChart1catCaption": "נקודות",
  "pointChart1catDataSlot_valuesLabel": "ערך",
  "pointChart1catDataSlot_categoriesLabel": "תווית ציר",
  "pointChart1catProp_colorPaletteLabel": "בוררי צבעים",
  "pointChart1catProp_elementColorLabel": "צבע צורה",
  "pointChart1catProp_symbolShapeLabel": "צורת סמל",
  "pointChart1catProp_symbolFillLabel": "מילוי צורה",
  "pointChart1catProp_symbolFillDescription": "הצגת צבע מילוי עבור סמלים.",
  "pointChart1catProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "pointChart1catProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "pointChart1catProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "pointChart1catProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "pointChart1catProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "pointChart1catProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "pointChart1catProp_suppressZerosLabel": "הסתרת ריק",
  "pointChart1catProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "scatterPlotChartNoCatCaption": "תרשים פיזור",
  "scatterPlotChartNoCatDataSlot_xAxisLabel": "ציר אופקי",
  "scatterPlotChartNoCatDataSlot_yAxisLabel": "ציר אנכי",
  "scatterPlotChartNoCatProp_colorPaletteLabel": "בוררי צבעים",
  "scatterPlotChartNoCatProp_elementColorLabel": "צבע מרכיבים",
  "scatterPlotChartNoCatProp_symbolShapeLabel": "צורת סמל",
  "scatterPlotChartNoCatProp_symbolFillLabel": "מילוי צורה",
  "scatterPlotChartNoCatProp_symbolFillDescription": "הצגת צבע מילוי עבור סמלים.",
  "scatterPlotChartNoCatProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "scatterPlotChartNoCatProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "radialBarChartCaption": "תרשים שעון",
  "radialBarChartDataSlot_categoriesLabel": "קטגוריות",
  "radialBarChartDataSlot_valuesLabel": "ערך",
  "radialBarChartProp_colorPaletteLabel": "בוררי צבעים",
  "radialBarChartProp_elementColorLabel": "צבע עמודה מוקדית",
  "radialBarChartProp_hideRadialTitleLabel": "הסתרת כותרת",
  "radialBarChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "radialBarChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "radialBarChartProp_suppressZerosLabel": "הסתרת ריק",
  "radialBarChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "lineColumnComboChartCaption": "קו ועמודה",
  "lineColumnComboChartDataSlot_categoryLabel": "תווית ציר",
  "lineColumnComboChartDataSlot_lineValueLabel": "ערך קו",
  "lineColumnComboChartDataSlot_columnValueLabel": "ערך עמודה",
  "lineColumnComboChartProp_colorPaletteLabel": "בוררי צבעים",
  "lineColumnComboChartProp_elementColorLabel": "צבע עמודה",
  "lineColumnComboChartProp_lineColorLabel": "צבע קווים וסמלים",
  "lineColumnComboChartProp_symbolShapeLabel": "צורת סמל",
  "lineColumnComboChartProp_hideSymbolsLabel": "הסתרת סמלים",
  "lineColumnComboChartProp_hideSymbolsDescription": "הסתרת סמלים",
  "lineColumnComboChartProp_hideDataLinesLabel": "הסתרת קווים",
  "lineColumnComboChartProp_hideDataLinesDescription": "הסתרת קווים",
  "lineColumnComboChartProp_interpolationLabel": "קווים חלקים",
  "lineColumnComboChartProp_interpolationDescription": "הקווים המתחברים לנקודות הנתונים מעוקלים.",
  "lineColumnComboChartProp_hideGridLinesLabel": "הסתרת קווי סריג",
  "lineColumnComboChartProp_hideGridLinesDescription": "הסתרת קווי סריג",
  "lineColumnComboChartProp_hideAxisTitleLabelsLabel": "הסתרת תוויות כותרת ציר",
  "lineColumnComboChartProp_hideAxisTitleLabelsDescription": "הסתרת הכותרות עבור הצירים.",
  "lineColumnComboChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "lineColumnComboChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "lineColumnComboChartProp_suppressZerosLabel": "הסתרת ריק",
  "lineColumnComboChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "lineColumnComboChartProp_hideLegendLabel": "הסתרת מקרא",
  "lineColumnComboChartProp_hideLegendDescription": "הסתרת המקרא.",
  "lineColumnComboChartProp_legendPositionLabel": "מיקום מקרא",
  "summaryCaption": "סיכום",
  "areaName": "שטחים",
  "areaDescription": "שטחים",
  "areaDataSlot_colorLabel": "צבע לפי",
  "areaDataSlot_valuesLabel": "ערך",
  "areaDataSlot_categoriesLabel": "תווית ציר",
  "bubbleName": "בועות",
  "bubbleDescription": "בועות",
  "bubbleDataSlot_yAxisLabel": "ציר אנכי",
  "bubbleDataSlot_xAxisLabel": "ציר אופקי",
  "bubbleDataSlot_sizeLabel": "גודל לפי",
  "bubbleDataSlot_colorLabel": "צבע לפי",
  "clusterBarName": "טורים",
  "clusterBarDescription": "טורים",
  "clusterBarDataSlot_colorLabel": "צבע לפי",
  "clusterBarDataSlot_valuesLabel": "ערך",
  "clusterBarDataSlot_categoriesLabel": "תווית ציר",
  "clusterBarDataSlot_valuesRepeatingLabel": "ערך",
  "clusterColumnName": "עמודה",
  "clusterColumnDescription": "עמודה",
  "clusterColumnDataSlot_colorLabel": "צבע לפי",
  "clusterColumnDataSlot_valuesLabel": "ערך",
  "clusterColumnDataSlot_categoriesLabel": "תווית ציר",
  "clusterColumnDataSlot_valuesRepeatingLabel": "ערך",
  "clusterLineName": "קו",
  "clusterLineDescription": "קו",
  "clusterLineDataSlot_colorLabel": "צבע לפי",
  "clusterLineDataSlot_valuesLabel": "ציר אנכי",
  "clusterLineDataSlot_categoriesLabel": "ציר אופקי",
  "clusterLineDataSlot_valuesRepeatingLabel": "ערך",
  "gridName": "סריג",
  "gridDescription": "סריג",
  "gridDataSlot_grid_colsLabel": "עמודה",
  "heatName": "חום",
  "heatDescription": "חום",
  "heatDataSlot_yAxisLabel": "ציר אנכי",
  "heatDataSlot_xAxisLabel": "ציר אופקי",
  "heatDataSlot_valuesLabel": "חום לפי",
  "lineColumnComboName": "קו ועמודה",
  "lineColumnComboDescription": "קו ועמודה",
  "lineColumnComboDataSlot_lineValueLabel": "ערך קו",
  "lineColumnComboDataSlot_categoryLabel": "תווית ציר",
  "lineColumnComboDataSlot_columnValueLabel": "ערך עמודה",
  "mapName": "מפה מגרסאות קודמות",
  "mapDescription": "מפה מגרסאות קודמות",
  "mapDataSlot_sizeLabel": "גודל נקודה",
  "mapDataSlot_valuesLabel": "חום שטחים",
  "mapDataSlot_sizeHeatLabel": "חום נקודות",
  "mapDataSlot_categoriesLabel": "אזורים",
  "packedBubbleName": "בועות דחוס",
  "packedBubbleDescription": "בועות דחוס",
  "packedBubbleDataSlot_sizeLabel": "גודל לפי",
  "packedBubbleDataSlot_colorLabel": "צבע לפי",
  "packedBubbleDataSlot_categoriesLabel": "קטגוריות",
  "pieName": "עוגה",
  "pieDescription": "עוגה",
  "pieDataSlot_valuesLabel": "ערך",
  "pieDataSlot_categoriesLabel": "קטגוריות",
  "playerName": "נגן נתונים",
  "playerDescription": "נגן נתונים",
  "playerDataSlot_categoriesLabel": "תווית ציר",
  "pointName": "נקודות",
  "pointDescription": "נקודות",
  "pointDataSlot_colorLabel": "צבע לפי",
  "pointDataSlot_valuesLabel": "ערך",
  "pointDataSlot_categoriesLabel": "תווית ציר",
  "radialName": "רדיאלי",
  "radialDescription": "רדיאלי",
  "radialDataSlot_valuesLabel": "ערך",
  "radialDataSlot_maxSizeLabel": "ערך מקסימום",
  "radialDataSlot_categoriesLabel": "קטגוריות",
  "radialBarName": "תרשים שעון",
  "radialBarDescription": "תרשים שעון",
  "radialBarDataSlot_valuesLabel": "ערך",
  "radialBarDataSlot_categoriesLabel": "קטגוריות",
  "scatterPlotName": "תרשים פיזור",
  "scatterPlotDescription": "תרשים פיזור",
  "scatterPlotDataSlot_yAxisLabel": "ציר אנכי",
  "scatterPlotDataSlot_xAxisLabel": "ציר אופקי",
  "scatterPlotDataSlot_colorLabel": "צבע לפי",
  "scatterPlotDataSlot_categoriesLabel": "נקודות",
  "stackedBarName": "טורים מוערמים",
  "stackedBarDescription": "טורים מוערמים",
  "stackedBarDataSlot_colorLabel": "צבע לפי",
  "stackedBarDataSlot_valuesLabel": "ערך",
  "stackedBarDataSlot_categoriesLabel": "תווית ציר",
  "stackedBarDataSlot_valuesRepeatingLabel": "ערך",
  "stackedColumnName": "עמודות מוערמות",
  "stackedColumnDescription": "עמודות מוערמות",
  "stackedColumnDataSlot_colorLabel": "צבע לפי",
  "stackedColumnDataSlot_valuesLabel": "ערך",
  "stackedColumnDataSlot_categoriesLabel": "תווית ציר",
  "stackedColumnDataSlot_valuesRepeatingLabel": "ערך",
  "summaryChartName": "סיכום",
  "summaryChartDescription": "סיכום",
  "summaryChartDataSlot_valuesLabel": "ערך",
  "treeMapName": "מפת עץ",
  "treeMapDescription": "מפת עץ",
  "treeMapDataSlot_colorLabel": "חום לפי",
  "treeMapDataSlot_valuesLabel": "גודל לפי",
  "treeMapDataSlot_categoriesLabel": "רמה אחת",
  "treeMapDataSlot_level3Label": "רמה שלוש",
  "treeMapDataSlot_level2Label": "רמה שתיים",
  "wordCloudName": "ענן מילים",
  "wordCloudDescription": "ענן מילים",
  "wordCloudDataSlot_colorLabel": "צבע לפי",
  "wordCloudDataSlot_scaleLabel": "גודל לפי",
  "wordCloudDataSlot_wordLabel": "מילים",
  "treeMap1Cat1MeasureChartCaption": "מפת עץ",
  "treeMap1Cat1MeasureChartDataSlot_categoriesLabel": "רמה אחת",
  "treeMap1Cat1MeasureChartDataSlot_valuesLabel": "גודל לפי",
  "treeMap1Cat1MeasureChartProp_colorPaletteLabel": "בוררי צבעים",
  "treeMap1Cat2MeasureChartProp_colorPaletteLabel": "בוררי צבעים",
  "treeMap2Cat1MeasureChartProp_colorPaletteLabel": "בוררי צבעים",
  "treeMap2Cat2MeasureChartProp_colorPaletteLabel": "בוררי צבעים",
  "treeMap3Cat1MeasureChartProp_colorPaletteLabel": "בוררי צבעים",
  "treeMap3Cat2MeasureChartProp_colorPaletteLabel": "בוררי צבעים",
  "treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "treeMap1Cat1MeasureChartProp_suppressZerosLabel": "הסתרת ריק",
  "treeMap1Cat1MeasureChartProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "treeMap1Cat1MeasureChartProp_hideLegendLabel": "הסתרת מקרא",
  "treeMap1Cat1MeasureChartProp_hideLegendDescription": "הסתרת המקרא.",
  "treeMap1Cat1MeasureChartProp_legendPositionLabel": "מיקום מקרא",
  "wordChart1Cat1MeasureCaption": "ענן מילים",
  "wordChart1Cat1MeasureDataSlot_wordLabel": "מילים",
  "wordChart1Cat1MeasureDataSlot_scaleLabel": "גודל לפי",
  "wordChart1Cat1MeasureProp_colorPaletteLabel": "בוררי צבעים",
  "wordChart1Cat1MeasureProp_elementColorLabel": "צבע מילה",
  "wordChart1Cat1MeasureProp_maintainAxisScalesLabel": "שמירת קנה מידה של ציר",
  "wordChart1Cat1MeasureProp_maintainAxisScalesDescription": "תמיד להציג ערכי מינימום ומקסימום על הצירים.",
  "wordChart1Cat1MeasureProp_suppressZerosLabel": "הסתרת ריק",
  "wordChart1Cat1MeasureProp_suppressZerosDescription": "הסתרת קטגוריות שאין להן ערכים משויכים.",
  "missingDataSetData": "הנתונים עבור ערכת נתונים זו אינם זמינים. רעננו את ערכת הנתונים או פנו למנהלן כדי לקבל גישה למקור.",
  "hideShowSummaries": "הסתרת סיכומי מצגת",
  "crosstabName": "הצלבת נתונים בטבלה",
  "value_is_not_available": "לא ישים",
  "swapRowsAndColumns": "החלפת שורות ועמודות",
  "NoPinsCollected": "אין המחשות נעוצות",
  "pinSearchOld": "חיפוש בנעיצות שלי שלי",
  "pinDeletedToast": "הנעיצה סולקה",
  "pinAddedToast": "הנעיצה נוספה בהצלחה אל 'הנעיצות שלי'.",
  "pinRetrieveError": "לא ניתן לאחזר נעיצה אחת או יותר. נסו שוב מאוחר יותר.",
  "pinErrorTitle": "שגיאה נעיצה",
  "pinRemove": "סילוק הנעיצה",
  "deletePin": "מחיקת הנעיצה",
  "dataset_time": "שעה",
  "dataset_date": "תאריך",
  "dataset_location": "מיקום",
  "dataset_number": "מספר",
  "dataset_text": "תמליל",
  "widgetConditionalFormatLabel": "מיתוג בקרות עיצוב מותנה",
  "deletePinConfirmationMessage": "אתם בטוחים שברצונכם למחוק נעיצה זו? לא ניתן לבטל פעולה זו.",
  "deletePinConfirm": "אישור מחיקה",
  "pinDeleteError": "לא ניתן למחוק נעיצה אחת או יותר. נסו שוב מאוחר יותר.",
  "conditionalPalettePickerLabel": "התפלגות של ערכי %{title}",
  "HistogramYAxisTitle": "ספירה",
  "metadataPickerTitle": "יצירת ערכת נתונים",
  "moreTitle": "עוד",
  "remove_slider_handle": "סילוק ידית",
  "missingFiltering": "עמודה חסרה:",
  "unSupportedPromptType": "תרחיש ההנחיות אינו נתמך כרגע.",
  "previewUnavailable": "מגש הנתונים והמסננים גלובליים אינם זמינים עבור מארזי Framework Manager.‏",
  "preAggregateLabel": "החלת ערכי הנחיות ממקור הנתונים",
  "postAggregateLabel": "החלת ערכי הנחיות בדוח",
  "preAggregateText": "הטווח משתמש בערכים שבמקור הנתונים, לא בערכים המוצגים בלוח המחוונים.",
  "tabName_general": "כללי",
  "tabName_visDetails": "פרטים",
  "tabName_animation": "הנפשה",
  "tabName_textDetails": "פרטי תמליל",
  "tabName_mediaDetails": "פרטי מדיה",
  "tabName_webDetails": "פרטי דף רשת",
  "tabName_imageDetails": "פרטי תמונה",
  "timelineSettingsButton": "אפשרויות הרצה",
  "autoPlay": "הרצת כל הסצנות",
  "loop": "לולאה",
  "propAniAnimation": "הנפשה",
  "propAniTypeEntrance": "הנפשת כניסה",
  "propAniDirectionIn": "כיוון כניסה",
  "propAniTypeExit": "הנפשת יציאה",
  "propAniDirectionOut": "כיוון יציאה",
  "propAniDirection": "כיוון",
  "filter_includesAll": "כולל הכל",
  "timeline_filter_moved_to": "מסנן ציר הזמן %{id} הועבר אל %{time}",
  "addDataSourceDialogTitle": "הוספת מקור נתונים",
  "addDataSourceDialogButtonLabel": "הוספה",
  "shapesDoubleChevron": "שברון כפלו",
  "widgetsPanelTitle": "פקדים",
  "widgetsPanelImageLibraryTab": "ספריית תמונות",
  "widgetsPanelSectionBasic": "בסיסי",
  "widgetsPanelSectionShapes": "צורות",
  "filterItemCanvasMove": "הוספת יריעה",
  "filterOverflowMenu_Global": "תפריט גלישה של כל הלשוניות",
  "filterOverflowMenu_Tab": "תפריט גלישה של לשונית זו",
  "filterOverflowMenu_Item": "סינון תפריט גלישה",
  "filterOverflowMenu_Single": "תפריט גלישה",
  "filterItemEdit": "עריכת ערכי מסנן",
  "filterDeleteAllItems": "מחיקת כל המסננים",
  "filterClearAllItems": "ניקוי כל המסננים",
  "filterClearSelection": "ניקוי מסנן",
  "filterPlayerMode": "הצגת נגן",
  "filterStaticMode": "הצגת רשימה",
  "filterInvertSelection": "היפוך מסנן",
  "filterIconLabel_Global": "כל הלשוניות",
  "filterIconLabel_Single": "מסננים",
  "filterIconLabel_Tab": "לשונית זו",
  "filterIconTooltip_Global": "כל הלשוניות",
  "filterIconTooltip_Tab": "לשונית זו",
  "filterIconTooltip_Single": "מסננים",
  "filterItemDelete": "מחיקת מסנן",
  "filterValueSeparator": ",",
  "filterRange": "%{from}-%{to}",
  "filterInvertRange": "הכל מלבד: %{from}-%{to}",
  "filterExcept": "מלבד %{values}",
  "filterAll": "הכל",
  "filterBlank": "(ריק)",
  "filterDisableRangeInvert": "לא זמין כשעמודה זו נמצאת במסנן 'כל הלשוניות'.‏",
  "filterDisableHierarchyInvert": "לא זמין כשעמודה זו היא מסנן היררכיה.",
  "filterSelectedOfTotal": "%{selected} מתוך %{totalMembers}",
  "filter_date_before": "לפני %{to}",
  "filter_date_before_except": "לא לפני %{to}",
  "filter_date_after": "לאחר %{from}",
  "filter_date_after_except": "לא אחרי %{from}",
  "filter_date_between": "בין %{from}-%{to}",
  "filter_date_between_except": "לא בין %{from}-%{to}",
  "filter_drag_and_drop_all_tabs": "גררו ושחררו נתונים כאן כדי לסנן את כל הלשוניות.",
  "filter_drag_and_drop_current_tab": "גררו ושחררו נתונים כאן כדי לסנן לשונית זו.",
  "filter_drag_and_drop_single_dock": "גררו ושחררו נתונים כאן כדי לסנן.",
  "errMsgFilterItemGenericTitle": "לא ניתן לטעון את ערכי המסנן",
  "widgetChromeRotate": "סיבוב",
  "toolbarRegionLabel": "סרגל כלים",
  "toolbarActionDelete": "מחיקה",
  "toolbarActionGroup": "קיבוץ",
  "toolbarActionUngroup": "ביטול קיבוץ",
  "toolbarActionOrderToFront": "משלוח לחזית",
  "toolbarActionOrderToBack": "משלוח לרקע",
  "toolbarActionEditTitle": "עריכת הכותרת",
  "toolbarActionPin": "איסוף",
  "toolbarActionPinOld": "נעיצה",
  "toolbarChangeVisualization": "שינוי המחשה",
  "live_label": "תרשים",
  "filter_label": "מסנן",
  "one_named_live": "תרשים %{name}",
  "one_named_live_numbered": "תרשים %{name} ‏(%{number})",
  "one_unknown_live": "תרשים",
  "one_unknown_live_numbered": "תרשים  (%{number})",
  "few_live": "קבוצה של %{count} תרשימים",
  "many_live": "קבוצה של %{count} תרשימים",
  "one_custom": "פקד מותאם",
  "one_custom_named": "%{name}",
  "one_custom_named_numbered": "%{name} (%{number})",
  "one_named_filter": "מסנן %{name}",
  "one_named_filter_numbered": "מסנן %{name} (%{number})",
  "one_unknown_filter": "מסנן",
  "one_unknown_filter_numbered": "מסנן (%{number})",
  "few_filter": "קבוצה של %{count} מסננים",
  "many_filter": "קבוצה של %{count} מסננים",
  "LIVE_bar_has_mapping": "תרשים טורים של %{categories} לפי %{values}",
  "LIVE_bar_has_mapping_numbered": "תרשים טורים של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_bar_no_mapping": "תרשים טורים ריק",
  "LIVE_bar_no_mapping_numbered": "תרשים טורים ריק (%{number})",
  "LIVE_bar_named": "תרשים טורים %{name}",
  "LIVE_bar_named_numbered": "תרשים טורים %{name} ‏(%{number})",
  "LIVE_stacked_bar_has_mapping": "תרשים טורים מוערם של %{categories} לפי %{values}",
  "LIVE_stacked_bar_has_mapping_numbered": "תרשים טורים מוערם של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_stacked_bar_no_mapping": "תרשים טורים מוערם ריק",
  "LIVE_stacked_bar_no_mapping_numbered": "תרשים טורים מוערם ריק (%{number})",
  "LIVE_stacked_bar_named": "תרשים טורים מוערם %{name}",
  "LIVE_stacked_bar_named_numbered": "תרשים טורים מוערם %{name} ‏(%{number})",
  "LIVE_bubble_has_mapping": "תרשים בועות של %{categories} לפי %{x} ולפי %{y}",
  "LIVE_bubble_has_mapping_numbered": "תרשים בועות של %{categories} לפי %{x} ולפי %{y} ‏(%{number})",
  "LIVE_bubble_no_mapping": "תרשים בועות ריק",
  "LIVE_bubble_no_mapping_numbered": "תרשים בועות ריק (%{number})",
  "LIVE_bubble_named": "תרשים בועות %{name}",
  "LIVE_bubble_named_numbered": "תרשים בועות %{name} ‏(%{number})",
  "LIVE_composite_has_mapping": "תרשים מרוכב של %{categories} לפי %{columnValue} ולפי %{lineValue}",
  "LIVE_composite_has_mapping_numbered": "תרשים מרוכב של %{categories} לפי %{columnValue} ולפי %{lineValue} ‏(%{number})",
  "LIVE_composite_no_mapping": "תרשים מרוכב ריק",
  "LIVE_composite_no_mapping_numbered": "תרשים מרוכב ריק (%{number})",
  "LIVE_composite_named": "תרשים מרוכב %{name}",
  "LIVE_composite_named_numbered": "תרשים מרוכב %{name} ‏(%{number})",
  "LIVE_decision_tree_has_mapping": "עץ החלטה %{values}",
  "LIVE_decision_tree_has_mapping_numbered": "עץ החלטה %{values} ‏(%{number})",
  "LIVE_decision_tree_no_mapping": "עץ החלטה ריק",
  "LIVE_decision_tree_no_mapping_numbered": "עץ החלטה ריק (%{number})",
  "LIVE_decision_tree_named": "עץ החלטה %{name}",
  "LIVE_decision_tree_named_numbered": "עץ החלטה %{name} ‏(%{number})",
  "LIVE_packed_bubble_has_mapping": "תרשים בועות דחוס של %{categories}",
  "LIVE_packed_bubble_has_mapping_numbered": "תרשים בועות דחוס של %{categories} ‏(%{number})",
  "LIVE_packed_bubble_no_mapping": "תרשים בועות דחוס ריק",
  "LIVE_packed_bubble_no_mapping_numbered": "תרשים בועות דחוס ריק ‏(%{number})",
  "LIVE_packed_bubble_named": "תרשים בועות דחוס %{name}",
  "LIVE_packed_bubble_named_numbered": "תרשים בועות דחוס %{name} ‏(%{number})",
  "LIVE_pie_has_mapping": "תרשים עוגה של %{categories} לפי %{values}",
  "LIVE_pie_has_mapping_numbered": "תרשים עוגה של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_pie_no_mapping": "תרשים עוגה ריק",
  "LIVE_pie_no_mapping_numbered": "תרשים עוגה ריק (%{number})",
  "LIVE_pie_named": "תרשים עוגה %{name}",
  "LIVE_pie_named_numbered": "תרשים עוגה %{name} ‏(%{number})",
  "LIVE_pie_as_donut_has_mapping": "תרשים טבעת של %{categories} לפי %{values}",
  "LIVE_pie_as_donut_has_mapping_numbered": "תרשים טבעת של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_pie_as_donut_no_mapping": "תרשים טבעת ריק",
  "LIVE_pie_as_donut_no_mapping_numbered": "תרשים טבעת ריק (%{number})",
  "LIVE_pie_as_donut_named": "תרשים טבעת %{name}",
  "LIVE_pie_as_donut_named_numbered": "תרשים טבעת %{name} ‏(%{number})",
  "LIVE_line_has_mapping": "תרשים קווים של %{categories} לפי %{values}",
  "LIVE_line_has_mapping_numbered": "תרשים קווים של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_line_no_mapping": "תרשים קווים ריק",
  "LIVE_line_no_mapping_numbered": "תרשים קווים ריק (%{number})",
  "LIVE_line_named": "תרשים קווים %{name}",
  "LIVE_line_named_numbered": "תרשים קווים %{name} ‏(%{number})",
  "LIVE_area_has_mapping": "תרשים שטחים של %{categories} לפי %{values}",
  "LIVE_area_has_mapping_numbered": "תרשים שטחים של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_area_no_mapping": "תרשים שטחים ריק",
  "LIVE_area_no_mapping_numbered": "תרשים שטחים ריק (%{number})",
  "LIVE_area_named": "תרשים שטחים %{name}",
  "LIVE_area_named_numbered": "תרשים שטחים %{name} ‏(%{number})",
  "LIVE_area_as_stacked_percent_has_mapping": "תרשים שטחים מוערם באחוזים של %{categories} לפי %{values}",
  "LIVE_area_as_stacked_percent_has_mapping_numbered": "תרשים שטחים מוערם באחוזים של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_area_as_stacked_percent_no_mapping": "תרשים שטחים מוערם באחוזים ריק",
  "LIVE_area_as_stacked_percent_no_mapping_numbered": "תרשים שטחים מוערם באחוזים ריק ‏(%{number})",
  "LIVE_area_as_stacked_percent_named": "תרשים שטחים מוערם באחוזים %{name}",
  "LIVE_area_as_stacked_percent_named_numbered": "תרשים שטחים מוערם באחוזים  %{name} ‏(%{number})",
  "LIVE_heatmap_has_mapping": "מפת חום של %{categories} לפי %{color}",
  "LIVE_heatmap_has_mapping_numbered": "מפת חום של %{categories} לפי %{color} ‏(%{number})",
  "LIVE_heatmap_no_mapping": "מפת חום ריקה",
  "LIVE_heatmap_no_mapping_numbered": "מפת חום ריקה (%{number})",
  "LIVE_heatmap_named": "מפת חום %{name}",
  "LIVE_heatmap_named_numbered": "מפת חום %{name} ‏(%{number})",
  "LIVE_network_has_mapping": "תרשים רשת של %{categories} לפי %{series} ולפי %{values}",
  "LIVE_network_has_mapping_numbered": "תרשים רשת של %{categories} לפי %{series} ולפי %{values} ‏(%{number})",
  "LIVE_network_no_mapping": "תרשים רשת ריק",
  "LIVE_network_no_mapping_numbered": "תרשים רשת ריק (%{number})",
  "LIVE_network_named": "תרשים רשת %{name}",
  "LIVE_network_named_numbered": "תרשים רשת %{name} ‏(%{number})",
  "LIVE_radial_bar_has_mapping": "תרשים עמודות מוקדי של %{categories} לפי %{values}",
  "LIVE_radial_bar_has_mapping_numbered": "תרשים עמודות מוקדי של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_radial_bar_no_mapping": "תרשים עמודות מוקדי ריק",
  "LIVE_radial_bar_no_mapping_numbered": "תרשים עמודות מוקדי ריק ‏(%{number})",
  "LIVE_radial_bar_named": "תרשים עמודות מוקדי %{name}",
  "LIVE_radial_bar_named_numbered": "תרשים עמודות מוקדי %{name} ‏(%{number})",
  "LIVE_spiral_has_mapping": "תרשים חלזוני של %{values}",
  "LIVE_spiral_has_mapping_numbered": "תרשים חלזוני של %{values} ‏(%{number})",
  "LIVE_spiral_no_mapping": "תרשים חלזוני ריק",
  "LIVE_spiral_no_mapping_numbered": "תרשים חלזוני ריק (%{number})",
  "LIVE_spiral_named": "תרשים חלזוני %{name}",
  "LIVE_spiral_named_numbered": "תרשים חלזוני %{name} ‏(%{number})",
  "LIVE_treemap_has_mapping": "מפת עץ של %{categories} לפי %{size}",
  "LIVE_treemap_has_mapping_numbered": "מפת עץ של %{categories} לפי %{size} ‏(%{number})",
  "LIVE_treemap_no_mapping": "מפת עץ ריקה",
  "LIVE_treemap_no_mapping_numbered": "מפת עץ ריקה (%{number})",
  "LIVE_treemap_named": "מפת עץ %{name}",
  "LIVE_treemap_named_numbered": "מפת עץ %{name} ‏(%{number})",
  "LIVE_wordcloud_has_mapping": "ענן מילים של %{categories}",
  "LIVE_wordcloud_has_mapping_numbered": "ענן מילים %{categories} ‏(%{number})",
  "LIVE_wordcloud_no_mapping": "ענן מילים ריק",
  "LIVE_wordcloud_no_mapping_numbered": "ענן מילים ריק (%{number})",
  "LIVE_wordcloud_named": "ענן מילים %{name}",
  "LIVE_wordcloud_named_numbered": "ענן מילים %{name} ‏(%{number})",
  "LIVE_data_player_has_mapping": "נגן נתונים %{category}",
  "LIVE_data_player_has_mapping_numbered": "נגן נתונים %{category} ‏(%{number})",
  "LIVE_data_player_no_mapping": "נגן נתונים ריק",
  "LIVE_data_player_no_mapping_numbered": "נגן נתונים ריק ‏(%{number})",
  "LIVE_data_player_named": "נגן נתונים %{name}",
  "LIVE_data_player_named_numbered": "נגן נתונים %{name} ‏(%{number})",
  "LIVE_map_has_mapping": "מפה של %{locations}",
  "LIVE_map_has_mapping_numbered": "מפה של %{locations} ‏(%{number})",
  "LIVE_map_no_mapping": "מפה ריקה",
  "LIVE_map_no_mapping_numbered": "מפה ריקה (%{number})",
  "LIVE_map_named": "מפה %{name}",
  "LIVE_map_named_numbered": "מפה %{name} ‏(%{number})",
  "LIVE_point_has_mapping": "תרשים נקודות של %{categories} לפי %{values}",
  "LIVE_point_has_mapping_numbered": "תרשים נקודות של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_point_no_mapping": "תרשים נקודות ריק",
  "LIVE_point_no_mapping_numbered": "תרשים נקודות ריק (%{number})",
  "LIVE_point_named": "תרשים נקודות %{name}",
  "LIVE_point_named_numbered": "תרשים נקודות %{name} ‏(%{number})",
  "LIVE_column_has_mapping": "תרשים עמודות של %{categories} לפי %{values}",
  "LIVE_column_has_mapping_numbered": "תרשים עמודות של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_column_no_mapping": "תרשים עמודות ריק",
  "LIVE_column_no_mapping_numbered": "תרשים עמודות ריק (%{number})",
  "LIVE_column_named": "תרשים עמודות %{name}",
  "LIVE_column_named_numbered": "תרשים עמודות %{name} ‏(%{number})",
  "LIVE_stacked_column_has_mapping": "תרשים עמודות מוערם של %{categories} לפי %{values}",
  "LIVE_stacked_column_has_mapping_numbered": "תרשים עמודות מוערם של %{categories} לפי %{values} ‏(%{number})",
  "LIVE_stacked_column_no_mapping": "תרשים עמודות מוערם ריק",
  "LIVE_stacked_column_no_mapping_numbered": "תרשים עמודות מוערם ריק (%{number})",
  "LIVE_stacked_column_named": "תרשים עמודות מוערם %{name}",
  "LIVE_stacked_column_named_numbered": "תרשים עמודות מוערם %{name} ‏(%{number})",
  "LIVE_empty_visualization_hint_title": "בנו את ההמחשה שלכם",
  "LIVE_empty_visualization_hint_description": "גררו ושחררו עמודות כאן או אל המשבצות משמאל.",
  "LIVE_slots_required_field_description": "%{asterisk} מציין שדה דרוש",
  "LIVE_slots_drag_and_drop_description": "גררו ושחררו נתונים במשבצות למעלה כדי לבנות ולסנן את ההמחשה",
  "requiredField": "שדה דרוש"
});
